import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faEye, faList, faPen, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { FormMode } from '../common/form-mode';

import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-detail-header',
    templateUrl: './detail-header.component.html',
    styleUrls: ['./detail-header.component.scss'],
    imports: [MatExpansionModule, MatTooltipModule, FaIconComponent, MatButtonModule, MatButtonToggleModule],
})
export class DetailHeaderComponent {
    /**
     * Liste des enums utilisés dans le template
     */
    public FormMode = FormMode;

    public faEdit = faPen;
    public faEye = faEye;
    public faQuestion = faQuestion;
    public faList = faList;

    @Input()
    formMode: FormMode;

    @Input()
    displayName: string;

    @Input()
    id: string;

    @Input()
    editRight: boolean = false;

    @Input()
    hideBackToListButton: boolean = false;

    @Output()
    displayed: EventEmitter<boolean> = new EventEmitter();

    @Output()
    edited: EventEmitter<boolean> = new EventEmitter();

    @Output()
    helped: EventEmitter<boolean> = new EventEmitter();

    @Output()
    backToList: EventEmitter<boolean> = new EventEmitter();

    constructor() {}

    public onEdition() {
        console.log('edition');
        this.edited.emit(true);
    }

    public onConsultation() {
        console.log('consultation');
        this.displayed.emit(true);
    }

    public onModeChange(event: MatButtonToggleChange) {
        if (event.value === 'reading') {
            this.displayed.emit(true);
        } else {
            this.edited.emit(true);
        }
    }

    public onHelp(): void {
        this.helped.emit(true);
    }

    public onBackToList(): void {
        this.backToList.emit(true);
    }
}
